import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { serializeAgentFromAPI } from './serializers';
import { AgentJSONAPIResponse, BetaTesterResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function fetchAgents() {
    const url = `${REQUEST_MANAGER_API_URL}/agency/agent`;

    const response = await apiClient.get<AgentJSONAPIResponse>(url);

    return serializeAgentFromAPI(response);
}

/**
 * [AT1_AUTO_EXPERIMENT] Fetches the list of agency IDs that are beta testers for AT1 auto settings
 * GET /experiments/at1-auto-settings/beta-tester
 * @returns Array of beta tester agencies
 */
export async function fetchBetaTesterAgencies(): Promise<BetaTesterResponse> {
    const url = `${REQUEST_MANAGER_API_URL}/experiments/at1-auto-settings/beta-tester`;
    return await apiClient.get<BetaTesterResponse>(url);
}
